import {
    DashboardOutlined,
    AppstoreOutlined,
    // MessageOutlined,
    SettingOutlined,
    AlertOutlined,
    BankOutlined,
    UserOutlined,
    UsergroupAddOutlined,
    EnvironmentOutlined,
    // ShopOutlined,
    HomeOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";

const settingsNavTree = [
    {
        key: "account",
        path: `${APP_PREFIX_PATH}/other`,
        title: "sidenav.account",
        icon: SettingOutlined,
        breadcrumb: true,
        submenu: [
            {
                key: "account-settings",
                path: `${APP_PREFIX_PATH}/account/settings`,
                title: "sidenav.account.settings",
                icon: SettingOutlined,
                breadcrumb: true,
                submenu: [],
            },
        ],
    },
];

const dashBoardNavTree = [
    {
        key: "dashboards",
        path: `${APP_PREFIX_PATH}/dashboards`,
        title: "sidenav.dashboard",
        icon: DashboardOutlined,
        breadcrumb: false,
        submenu: [
            {
                key: "dashboards-default",
                path: `${APP_PREFIX_PATH}/dashboards/default`,
                title: "sidenav.dashboard.dashboard",
                icon: DashboardOutlined,
                breadcrumb: false,
                submenu: [],
            },
        ],
    },
];

const appsNavTree = [
    {
        key: "apps",
        path: `${APP_PREFIX_PATH}/apps`,
        title: "sidenav.apps",
        icon: AppstoreOutlined,
        breadcrumb: false,
        submenu: [
            {
                key: "app-places",
                path: `${APP_PREFIX_PATH}/apps/places`,
                title: "sidenav.apps.places",
                icon: EnvironmentOutlined,
                breadcrumb: true,
                submenu: [
                    {
                        key: "apps-places-placeList",
                        path: `${APP_PREFIX_PATH}/apps/places/place-list`,
                        title: "sidenav.apps.places.placeList",
                        icon: "",
                        breadcrumb: true,
                        obj: { key: "Places", index: 0 },
                        submenu: [],
                    },
                    {
                        key: "apps-places-addPlace",
                        path: `${APP_PREFIX_PATH}/apps/places/add-place`,
                        title: "sidenav.apps.places.addPlace",
                        icon: "",
                        breadcrumb: false,
                        obj: { key: "Places", index: 1 },
                        submenu: [],
                    },
                ],
            },
            {
                key: "app-works",
                path: `${APP_PREFIX_PATH}/apps/works`,
                title: "sidenav.apps.works",
                icon: AlertOutlined,
                breadcrumb: true,
                submenu: [
                    {
                        key: "apps-works-workList",
                        path: `${APP_PREFIX_PATH}/apps/works/work-list`,
                        title: "sidenav.apps.works.workList",
                        icon: "",
                        breadcrumb: true,
                        obj: { key: "Works", index: 0 },
                        submenu: [],
                    },
                    {
                        key: "apps-works-workCommentList",
                        path: `${APP_PREFIX_PATH}/apps/works/work-comment`,
                        title: "sidenav.apps.works.workCommentList",
                        icon: "",
                        breadcrumb: true,
                        obj: { key: "Works", index: 0 },
                        submenu: [],
                    },
                    {
                        key: "apps-works-addWork",
                        path: `${APP_PREFIX_PATH}/apps/works/add-work`,
                        title: "sidenav.apps.works.addWork",
                        icon: "",
                        breadcrumb: false,
                        obj: { key: "Works", index: 1 },
                        submenu: [],
                    },
                    {
                        key: "apps-works-repeated",
                        path: `${APP_PREFIX_PATH}/apps/works/repeated-list`,
                        title: "sidenav.apps.works.repeated",
                        icon: "",
                        breadcrumb: true,
                        obj: { key: "Works", index: 1 },
                        submenu: [],
                    },
                ],
            },
            // {
            //     key: "apps-works",
            //     path: `${APP_PREFIX_PATH}/apps/works/work-list`,
            //     title: "sidenav.apps.works",
            //     icon: AimOutlined,
            //     breadcrumb: true,
            //     obj: { key: "Works", index: 0 },
            //     submenu: [],
            // },
            {
                key: "apps-users",
                path: `${APP_PREFIX_PATH}/apps/users/user-list`,
                title: "sidenav.apps.users",
                icon: UsergroupAddOutlined,
                breadcrumb: true,
                obj: { key: "Users", index: 0 },
                submenu: [],
            },
            {
                key: "states",
                path: `${APP_PREFIX_PATH}/apps/states`,
                title: "sidenav.apps.states",
                icon: BankOutlined,
                obj: { key: "States", index: 0 },
                breadcrumb: true,
                submenu: [],
            },
            {
                key: "apps-cities",
                path: `${APP_PREFIX_PATH}/apps/cities`,
                title: "sidenav.apps.cities",
                icon: HomeOutlined,
                breadcrumb: true,
                obj: { key: "Cities", index: 0 },
                submenu: [],
            },
            {
                key: "apps-roles",
                path: `${APP_PREFIX_PATH}/apps/roles/role-list`,
                title: "sidenav.apps.roles",
                icon: UserOutlined,
                breadcrumb: true,
                obj: { key: "Roles", index: 0 },
                submenu: [],
            },
            {
                key: "apps-statuses",
                path: `${APP_PREFIX_PATH}/apps/statuses`,
                title: "sidenav.apps.statuses",
                icon: UserOutlined,
                breadcrumb: true,
                obj: { key: "Statuses", index: 0 },
                submenu: [],
            },
            {
                key: "apps-privileges",
                path: `${APP_PREFIX_PATH}/apps/privileges`,
                title: "sidenav.apps.privileges",
                icon: UserOutlined,
                breadcrumb: true,
                obj: { key: "Privileges", index: 0 },
                submenu: [],
            },

            {
                key: "map",
                path: `${APP_PREFIX_PATH}/apps/map`,
                title: "sidenav.apps.map",
                icon: EnvironmentOutlined,
                breadcrumb: true,
                submenu: [],
            },
            // {
            //     key: "map2",
            //     path: `${APP_PREFIX_PATH}/apps/map2`,
            //     title: "sidenav.apps.map2",
            //     icon: MessageOutlined,
            //     breadcrumb: true,
            //     submenu: [],
            // },
            // {
            //     key: "testt",
            //     path: `${APP_PREFIX_PATH}/apps/test`,
            //     title: "sidenav.apps.test",
            //     icon: MessageOutlined,
            //     breadcrumb: true,
            //     submenu: [],
            // },
        ],
    },
];

const navigationConfig = [
    ...dashBoardNavTree,
    ...appsNavTree,
    ...settingsNavTree,
];

export default navigationConfig;
